// Recharge code
$(document).ready(function () {

  clearTheCart();

  function get_cookie(name) {
    return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2]
  };

  // Gets value from user input - assigns to selections object
  var setOptionEventHandler = function (option) {
    $("#" + option).click(function () {
      var $link = $(this).data("value");
      var v = $link;
      // Add values to selections object
      if ((v == "bio") || (v == "non-bio")) {
        selections.typeOfLiquid = v;
        trackEventInGa("Free Trial subscription page", "Question 1: Which type of detergent would you like?", "Clicked");
      } else if ((v == "one-capsule") || (v == "two-capsules")) {
        selections.numberOfCapsules = v;
        trackEventInGa("Free Trial subscription page", "Question 2: How many capsules do you use per wash?", "Clicked");
      }
    });
  }

  setOptionEventHandler("bio");
  setOptionEventHandler("bio-text");
  setOptionEventHandler("non-bio");
  setOptionEventHandler("non-bio-text");

  setOptionEventHandler("one-capsule");
  setOptionEventHandler("one-capsule-text");
  setOptionEventHandler("two-capsules");
  setOptionEventHandler("two-capsules-text");

  $("#display-arrow").click(function () {
    $("#frequency-options").addClass("show-options").removeClass("hidden-options");
  });

  $(".frequency-option").click(function () {
    trackEventInGa("Free Trial subscription page", "Question 3: How often do you run your machine?", "Clicked");

    $("#success").addClass("visible");
    $("#success").removeClass("hidden");

    var $numberOfWashes = $(this).data("value");
    $("#frequency-options").addClass("hidden-options");
    document.getElementById("display-arrow").innerHTML = $(this).data("value");
    document.getElementById("display-arrow").classList.add("value-display");
    selections.washesPerWeek = parseInt($numberOfWashes);
    setTimeout(function () {
      $("#checkout-button").show();
      $("#questions").scrollTo("#success", 1000);
    }, 600);
    setTimeout(function () {
      textAnimate();
    }, 500);

    // Delivery frequencies for standard drum sizes
    if (selections.numberOfCapsules == "one-capsule") {
      switch (selections.washesPerWeek) {
        case 1:
          selections.deliveryFrequency = 168;
          break;
        case 2:
          selections.deliveryFrequency = 84;
          break;
        case 3:
          selections.deliveryFrequency = 56;
          break;
        case 4:
          selections.deliveryFrequency = 42;
          break;
        case 5:
          selections.deliveryFrequency = 33;
          break;
        case 6:
          selections.deliveryFrequency = 28;
          break;
        case 7:
          selections.deliveryFrequency = 24;
          break;
        case 8:
          selections.deliveryFrequency = 21;
          break;
        case 9:
          selections.deliveryFrequency = 18;
          break;
        case 10:
          selections.deliveryFrequency = 16;
          break;
        case 11:
          selections.deliveryFrequency = 15;
          break;
        case 12:
          selections.deliveryFrequency = 14;
          break;
        case 13:
        case 14:
          selections.deliveryFrequency = 12;
          break;
        case 15:
          selections.deliveryFrequency = 11;
          break;
        case 16:
          selections.deliveryFrequency = 10;
          break;
        case 17:
        case 18:
          selections.deliveryFrequency = 9;
          break;
        case 19:
        case 20:
        case 21:
          selections.deliveryFrequency = 8;
          break;
        case 22:
        case 23:
        case 24:
          selections.deliveryFrequency = 7;
          break;
        case 25:
          selections.deliveryFrequency = 6;
      }
    }

    // Delivery frequency for large drum sizes
    if (selections.numberOfCapsules == "two-capsules") {
      switch (selections.washesPerWeek) {
        case 1:
          selections.deliveryFrequency = 84;
          break;
        case 2:
          selections.deliveryFrequency = 42;
          break;
        case 3:
          selections.deliveryFrequency = 28;
          break;
        case 4:
          selections.deliveryFrequency = 21;
          break;
        case 5:
          selections.deliveryFrequency = 16;
          break;
        case 6:
          selections.deliveryFrequency = 14;
          break;
        case 7:
          selections.deliveryFrequency = 12;
          break;
        case 8:
          selections.deliveryFrequency = 10;
          break;
        case 9:
          selections.deliveryFrequency = 9;
          break;
        case 10:
          selections.deliveryFrequency = 8;
          break;
        case 11:
        case 12:
          selections.deliveryFrequency = 7;
          break;
        case 13:
        case 14:
          selections.deliveryFrequency = 6;
          break;
        case 15:
        case 16:
          selections.deliveryFrequency = 5;
          break;
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
          selections.deliveryFrequency = 4;
          break;
        case 22:
        case 23:
        case 24:
        case 25:
          selections.deliveryFrequency = 3;
      }
    }

  });

  if (window.innerWidth <= 768) {

    $("#number-of-washes-select").change(function () {
      $("#success").addClass("visible");
      $("#success").removeClass("hidden");
      var $numberOfWashes = $(this).val();
      document.getElementById("display-arrow").innerHTML = $(this).val();
      document.getElementById("display-arrow").classList.add("value-display");
      selections.washesPerWeek = parseInt($numberOfWashes);

      /* Adding this to reset the scroll on event change. This then resets from where the page is scrolling, meaning the header is once again registered as being at the top of the page */
      $("html").scrollTo(0);

      setTimeout(function () {
        $("#checkout-button").show();

        $("#questions").scrollTo("#success", 1000);
      }, 600);
      setTimeout(function () {
        textAnimate();
      }, 500);

      // Delivery frequencies for standard drum sizes
      // These could use the same logic as the versions above
      if (selections.numberOfCapsules == "one-capsule") {
        switch (selections.washesPerWeek) {
          case 1:
            selections.deliveryFrequency = 168;
            break;
          case 2:
            selections.deliveryFrequency = 84;
            break;
          case 3:
            selections.deliveryFrequency = 56;
            break;
          case 4:
            selections.deliveryFrequency = 42;
            break;
          case 5:
            selections.deliveryFrequency = 33;
            break;
          case 6:
            selections.deliveryFrequency = 28;
            break;
          case 7:
            selections.deliveryFrequency = 24;
            break;
          case 8:
            selections.deliveryFrequency = 21;
            break;
          case 9:
            selections.deliveryFrequency = 18;
            break;
          case 10:
            selections.deliveryFrequency = 16;
            break;
          case 11:
            selections.deliveryFrequency = 15;
            break;
          case 12:
            selections.deliveryFrequency = 14;
            break;
          case 13:
          case 14:
            selections.deliveryFrequency = 12;
            break;
          case 15:
            selections.deliveryFrequency = 11;
            break;
          case 16:
            selections.deliveryFrequency = 10;
            break;
          case 17:
          case 18:
            selections.deliveryFrequency = 9;
            break;
          case 19:
          case 20:
          case 21:
            selections.deliveryFrequency = 8;
            break;
          case 22:
          case 23:
          case 24:
            selections.deliveryFrequency = 7;
            break;
          case 25:
            selections.deliveryFrequency = 6;
        }
      }

      // Delivery frequency for large drum sizes
      if (selections.numberOfCapsules == "two-capsules") {
        switch (selections.washesPerWeek) {
          case 1:
            selections.deliveryFrequency = 84;
            break;
          case 2:
            selections.deliveryFrequency = 42;
            break;
          case 3:
            selections.deliveryFrequency = 28;
            break;
          case 4:
            selections.deliveryFrequency = 21;
            break;
          case 5:
            selections.deliveryFrequency = 16;
            break;
          case 6:
            selections.deliveryFrequency = 14;
            break;
          case 7:
            selections.deliveryFrequency = 12;
            break;
          case 8:
            selections.deliveryFrequency = 10;
            break;
          case 9:
            selections.deliveryFrequency = 9;
            break;
          case 10:
            selections.deliveryFrequency = 8;
            break;
          case 11:
          case 12:
            selections.deliveryFrequency = 7;
            break;
          case 13:
          case 14:
            selections.deliveryFrequency = 6;
            break;
          case 15:
          case 16:
            selections.deliveryFrequency = 5;
            break;
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
            selections.deliveryFrequency = 4;
            break;
          case 22:
          case 23:
          case 24:
          case 25:
            selections.deliveryFrequency = 3;
        }
      }

    })
  }

  var bioSubscription;
  var nonBioSubscription;

  var bioTrial;
  var nonBioTrial;

  // No longer using cartJS
  // if (currentSiteLocation.includes("development")) {
  //   console.log("This is the development server");
  //   bioSubscription = bioSubscriptionId;
  //   nonBioSubscription = nonBioSubscriptionId;

  //   bioTrial = 13714197872705;
  //   nonBioTrial = 13714195349569;
  // } else {
  //   console.log("This is the production server");
  //   bioSubscription = bioSubscriptionId;
  //   nonBioSubscription = nonBioSubscriptionId;

  //   bioTrial = 5571317694493;
  //   nonBioTrial = 5758716084253;
  // }

  // Checkout button adds trial product to cart, based on selections.typeOfLiquid
  // $("#checkout-button").click(function () {
  //   CartJS.clear();

  //   trackEventInGa("Free Trial subscription page", "Proceed to checkout", "Clicked");

  //   var cartNote = "Type of liquid: " + selections.typeOfLiquid + "\n" + "Number of capsules per wash: " + selections.numberOfCapsules + "\n" + "Number of washes per week: " + selections.washesPerWeek;

  //   if (selections.typeOfLiquid == "bio") {
  //     CartJS.addItem(bioSubscription, 1, {
  //       "[charge_delay]": 10,
  //       "[recurring_price]": 3.85,
  //       "[shipping_interval_frequency]": selections.deliveryFrequency,
  //       "[shipping_interval_unit_type]": "Days"
  //     });
  //     CartJS.setNote(cartNote);
  //     CartJS.addItem(bioTrial, 1);
  //   } else if (selections.typeOfLiquid == "non-bio") {
  //     CartJS.addItem(nonBioSubscription, 1, {
  //       "[charge_delay]": 10,
  //       "[recurring_price]": 3.85,
  //       "[shipping_interval_frequency]": selections.deliveryFrequency,
  //       "[shipping_interval_unit_type]": "Days"
  //     });
  //     CartJS.setNote(cartNote);
  //     CartJS.addItem(nonBioTrial, 1);
  //   }
  // });


  var laundryCartNote;
  var laundryItem;
  var laundryTrial;

  var noteUpdated = false;
  var updatedCartNote = function () {
    noteUpdated = true;
    checkoutProcess();
  }

  // No longer needed since workflow switch
  var trialAdded = false;
  var addedTrialToCart = function () {
    trialAdded = true;
    checkoutProcess();
  }

  var itemAdded = false;
  var addedCartItem = function () {
    itemAdded = true;
    checkoutProcess();
  }

  var checkoutProcess = function () {
    // Ajax calls made to cart before processing by ReCharge
    if (!noteUpdated) {
      updateCartNote();
    } else {
      if (!itemAdded) {
        addItemToCart(laundryTrial, 1, selections.deliveryFrequency.toString(), "day", rechargeSubscriptionId);
      } else {
        reChargeProcessCart();
      }
    }
  };

  var checkCartIsEmpty = function () {
    clearTheCart();
    if (cartCleared) {
      checkoutProcess();
    } else {
      checkCartIsEmpty();
    }
  }

  $("#checkout-button").click(function (event) {

    if (selections.typeOfLiquid == "non-bio") {
      laundryItem = nonBioSubscriptionId;
      laundryTrial = nonBioTrialId;
    } else {
      laundryItem = bioSubscriptionId;
      laundryTrial = bioTrialId;
    }

    $("#checkout-button").hide();
    $(".cart-loader").addClass("visible");

    event.preventDefault();

    laundryCartNote = "Type of liquid: " + selections.typeOfLiquid + "\n" + "Number of capsules per wash: " + selections.numberOfCapsules + "\n" + "Number of washes per week: " + selections.washesPerWeek;

    if(cartCleared) {
      checkoutProcess();
    } else {
      checkCartIsEmpty();
    }

  });

  // Redirect to checkout page on cart population

  // var letMeCheckout = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + paramCart + "&" + customer_param + "&discount=K72WDJGGZ995VB9J";

  function updateCartNote() {
    note = {
      "note": laundryCartNote
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: note,
      dataType: "json",
      success: function () {
        updatedCartNote();
      },
      error: function () {
        return false;
      }
    })
  }

  // function addTrialToCart(trial_id, quantity) {
  //   data = {
  //     "quantity": quantity,
  //     "id": trial_id,
  //   }
  //   jQuery.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: data,
  //     dataType: "json",
  //     success: function () {
  //       addedTrialToCart();
  //     },
  //     error: function () {
  //       return false;
  //     }
  //   });
  // }

  function addItemToCart(variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id) {
    data = {
      "quantity": quantity,
      "id": variant_id,
      "properties[shipping_interval_frequency]": shipping_interval_frequency,
      "properties[shipping_interval_unit_type]": shipping_interval_unit_type,
      "properties[subscription_id]": subscription_id
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        addedCartItem();
      },
      error: function () {
        return false;
      }
    });
  }

});